import * as actionTypes from "../actions/actionTypes";

const initialState = {
  servicios: [],
  selectedServicio: null,
  errorMsg: "",
  servicioBuscado: [],
  favoritos: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SERVICIOS: {
      return {
        ...state,
        servicios: action.servicios,
        errorMsg: "",
      };
    }
    case actionTypes.SET_FAVORITOS: {
      return {
        ...state,
        favoritos: action.favoritos,
      };
    }
    case actionTypes.SET_SERVICIOS_FAILED: {
      return {
        ...state,
        errorMsg: action.errorMsg,
      };
    }
    case actionTypes.SET_SELECTED_SERVICIO: {
      return {
        ...state,
        selectedServicio: action.selectedServicio,
      };
    }
    case actionTypes.SET_SERVICIO_BUSCADO: {
      return {
        ...state,
        servicioBuscado: action.servicioBuscado,
      };
    }
    
    default:
      return state;
  }
};

export default reducer;
